module.exports = __webpack_public_path__ + "img/step3.bf1e3d86.png";